/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — pre-creates the Yousign signing iframe so its request
 *              carries a Referer
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      document
 *   siblings:  beebee-base-template bb-you-sign.js, beebeeboard-booking
 *              heliguides-personal-data.js / heliguides-sign-request.js (every
 *              `new Yousign({ iframeContainerId })` call site)
 *   tests:     -
 *   gotchas:   must run BEFORE `new Yousign(...)`: the SDK reuses an existing
 *              `#yousign-iframe` and only creates its own (with the page policy)
 *              when none is there.
 */

/**
 * The API serves every page with `Referrer-Policy: no-referrer` (Hono secureHeaders
 * default). Yousign decides whether its signing page may be framed by reading the
 * Referer of the iframe request ("Referer di origine sempre autorizzato" and the
 * allowed-domains list both depend on it): with no Referer it answers
 * `frame-ancestors 'none'` and the browser shows a broken frame. A per-element
 * `referrerpolicy` overrides the document policy for that one request only, so the
 * origin reaches Yousign without loosening the policy for the rest of the page.
 * The Yousign iframe SDK picks up an existing `#yousign-iframe` instead of creating
 * its own, so mounting it here first is enough.
 *
 * @param {string} containerId - id of the element passed to Yousign as `iframeContainerId`
 * @returns {HTMLIFrameElement|null} the iframe, or null when the container is not in the DOM
 */
function prepareYousignIframe(containerId) {
  if (typeof document === 'undefined') return null;
  let iframe = document.getElementById('yousign-iframe');
  if (!iframe) {
    const container = document.getElementById(containerId);
    if (!container) return null;
    iframe = document.createElement('iframe');
    iframe.id = 'yousign-iframe';
    iframe.title = 'Yousign';
    container.appendChild(iframe);
  }
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  return iframe;
}

export { prepareYousignIframe };
//# sourceMappingURL=yousign-iframe.js.map
